import React, { useEffect, useLayoutEffect, useState } from "react"
import DataTable from "react-data-table-component"
import PPTableCellPrice from "../../components/pricetable/PPTableCellPrice"
import PPPictureBoxLoad from "../../components/pricetable/PPPictureBoxLoad"
import PPLoadingIndicator from "../../components/layout/PPLoadingIndicator"
import PPExpandedRow from "../../components/pricetable/PPExpandedRow"
import "flag-icons/css/flag-icons.min.css"
import { useQuery, useMutation, useSubscription } from "@apollo/client"
import INSTANT_CRAWL_SUBSCRIPTION from "../../utils/const/InstantCrawlSub"

import i18n_iso_countrie_de from "i18n-iso-countries/langs/de.json"
import i18n_iso_countrie_en from "i18n-iso-countries/langs/en.json"
import countries from "i18n-iso-countries"
import PPErrorDisplay from "../../components/layout/PPErrorDisplay"
import { useParams, useLocation } from "react-router-dom"
import PPUtils from "../../utils/PPUtils"
import { useTranslation } from "react-i18next"
import { isStandalone } from "../../config/ppAiConfig"
import { toast } from "react-toastify"
import MappingState from "../../utils/const/MappingState"
import PPUploadImport from "../../components/pricetable/PPUploadImport"
import "../../styles/pricetable.css"
import "../../styles/righttab.css"

countries.registerLocale(i18n_iso_countrie_de)
countries.registerLocale(i18n_iso_countrie_en)

const ref = React.createRef()

const customStyles = {
    rows: {
        style: {
            // minHeight: '72px', // override the row height
        }
    },
    headCells: {
        style: {
            // paddingLeft: '8px', // override the cell padding for head cells
            // paddingRight: '8px',
        }
    },
    cells: {
        style: {
            // paddingLeft: '0px', // override the cell padding for data cells
            // paddingRight: '0px',
        }
    }
}
import { QUERY_MAINLANG, QUERY, PRICETABLE_EXPORT_QUERY } from "./pricetableQueries"
import { PPPriceTableHeader } from "./PPPriceTableHeader"

function PPPriceTable(props) {
    const [t, i18n] = useTranslation()
    const [perPage, setPerPage] = useState(25)
    const [filters, setFilters] = useState({})
    const [columns, setColumns] = useState([])
    const [mainLang, setMainLang] = useState(null)
    const [tariffComparisonMode, setTariffComparisonMode] = useState("N")

    const [page, setPage] = useState(1)
    const [sortDirection, setSortDirection] = useState(null)
    const [sortColumnName, setSortColumnName] = useState(null)
    const [currencyLang, setCurrencyLang] = useState(
        localStorage.getItem("switchCurrency") === "true" ? "anythingElse" : "de"
    )
    const [tmpPresetId, setTmpPresetId] = useState(null)

    let presetShopIds = {}

    let { filter, where, search, sortProperty, genericFilterProperty } = useParams()
    const location = useLocation()
    let currencyIsoCode = "EUR"

    // Lese shopId aus URL Query-Parametern
    const urlParams = new URLSearchParams(location.search)
    const shopIdFromUrl = urlParams.get('shopId')
    const shopIdFromUrlParsed = shopIdFromUrl ? parseInt(shopIdFromUrl, 10) : null

    if (genericFilterProperty?.length > 0) {
        filters.genericFilterProperty = genericFilterProperty
    } else if (search?.length > 0) {
        search = decodeURIComponent(search)
        search = search.replace(/\|\|/g, "/")
    }

    let variables = {
        perpage: perPage,
        page: page,
        sortDirection: sortDirection ? sortDirection.toUpperCase() : null,
        sortLang: null,
        propertyName: filters.genericFilterProperty
            ? filters.genericFilterProperty
            : sortColumnName
              ? sortColumnName.propertyName
              : sortProperty && !window.location.pathname.includes("/s/")
                ? sortProperty
                : null,
        genericFilter: filters.genericFilterProperty ? true : false,
        searchword: search ? search : null,

        presetId: props.presetId,

        department: filters.department !== "" ? filters.department : null,
        productGroup: filters.productgroup !== "" ? filters.productgroup : null,
        productCat: filters.productcat !== "" ? filters.productcat : null,
        productSubCat: filters.productsubcat !== "" ? filters.productsubcat : null,
        producer: filters.producer !== "" ? filters.producer : null,

        mappingState:
            sortProperty && !window.location.pathname.includes("/s/")
                ? MappingState.MAPPED
                : localStorage.getItem("mappingState"),
        buttoncatsearch: filters.buttoncatsearch ? filters.buttoncatsearch : false,

        pricetableShopId: shopIdFromUrlParsed || (filters.shopId !== null && filters.shopId !== undefined ? filters.shopId : null),
        sortShopId: shopIdFromUrlParsed || (filters.shopId !== null && filters.shopId !== undefined ? filters.shopId : null),
        sortRanking: localStorage.getItem("sortRanking") === "true" ? true : false,
        discontinuedItems: localStorage.getItem("switchDiscontinuedItems") === "true" ? true : false,
        sortMinPrice: -1,
        sortMaxPrice: -1,
        currencyLang: currencyLang,
        amazonBuyboxFilter: null,
        amazonBuyboxShopIds: null
    }

    const [triggerPricetableExport] = useMutation(PRICETABLE_EXPORT_QUERY, {
        variables: variables,
        fetchPolicy: "no-cache",
        onCompleted: () => {
            toast(t("export.started"))
        },
        onError: (error2) => {
            if (error2.message.toString().length > 0) {
                toast.error(t("export.start_failed"))
            }
        }
    })

    const { data: mainLangData } = useQuery(QUERY_MAINLANG, {
        skip: shouldSkip(),
        displayName: "GetMainLangQuery",
        fetchPolicy: "no-cache"
    })

    useEffect(() => {
        if (!mainLangData) return
        setMainLang(mainLangData.baseData.mainLang)
        setTariffComparisonMode(mainLangData.baseData.tariffComparisonMode)
        setCurrencyLang(localStorage.getItem("switchCurrency") === "true" ? "anythingElse" : mainLangData.baseData.mainLang)
    }, [mainLangData])

    if (sortColumnName?.shopId) {
        variables.sortShopId = sortColumnName.shopId
        variables.propertyName = sortColumnName.propertyName?.includes("foreignShop")
            ? sortColumnName.propertyName
            : "foreignShopPrice"
    } else if (
        sortColumnName &&
        (sortColumnName.propertyName === "priceRange" ||
            sortColumnName.amazonBuyboxFilter ||
            sortColumnName.minPrice != null ||
            sortColumnName.maxPrice != null)
    ) {
        variables.sortMinPrice = sortColumnName.minPrice != undefined ? sortColumnName.minPrice : -1
        variables.sortMaxPrice = sortColumnName.maxPrice != undefined ? sortColumnName.maxPrice : -1
        variables.sortLang = mainLang != null ? mainLang : "de"
        variables.amazonBuyboxFilter = sortColumnName.amazonBuyboxFilter || null
        variables.amazonBuyboxShopIds = sortColumnName.amazonBuyboxShopIds || null
    } else if (variables?.propertyName?.includes("price_")) {
        variables.sortLang = variables.propertyName.split("_")[1]
        variables.propertyName = "price"
    }

    function shouldSkip() {
        if (!props.presetId) {
            return true
        }
        return false
    }

    const { loading, error, data, refetch } = useQuery(QUERY, {
        skip: shouldSkip(),
        displayName: "PricetableQuery",
        variables: variables,
        fetchPolicy: "no-cache"
    })

    useEffect(() => {
        if (!data) return
        if (tmpPresetId !== props.presetId) {
            setTmpPresetId(props.presetId)
        }
        props.setRefetchPricetable({ ...{ refetch } })
    }, [data])

    // Bestimme shopId: Priorität: URL Query-Parameter > filters.shopId
    useEffect(() => {
        if (shopIdFromUrlParsed) {
            // Setze shopId immer, wenn sie in der URL vorhanden ist
            setFilters((prevFilters) => {
                if (prevFilters.shopId !== shopIdFromUrlParsed) {
                    return { ...prevFilters, shopId: shopIdFromUrlParsed }
                }
                return prevFilters
            })
        } else if (filters.shopId && !shopIdFromUrlParsed) {
            // Entferne shopId, wenn sie nicht mehr in der URL ist
            setFilters((prevFilters) => {
                const newFilters = { ...prevFilters }
                delete newFilters.shopId
                return newFilters
            })
        }
    }, [shopIdFromUrlParsed])

    useEffect(() => {
        if (!window.location.pathname.includes("/s/")) {
            switch (where) {
                case "Shop":
                    filters.shopId = filter
                    break
                case "Kategorie":
                    // Konvertiere "||" wieder zu "/" (wurde in der URL verwendet um URL-Probleme zu vermeiden)
                    filters.department = filter ? filter.replace(/\|\|/g, '/') : filter
                    break
                case "Hersteller":
                    // Konvertiere "||" wieder zu "/" (wurde in der URL verwendet um URL-Probleme zu vermeiden)
                    filters.producer = filter ? filter.replace(/\|\|/g, '/') : filter
                    break
                default:
                    break
            }
        }
        setFilters(filters)
    }, [filter, variables, where])

    useEffect(() => {
        if (props.presetId !== tmpPresetId) {
            setFilters({})
        }
    }, [props.presetId])

    useLayoutEffect(() => {
        const createShopColumns = (shops) => {
            // Filter nach shopId aus URL oder filters
            const shopIdToFilter = shopIdFromUrlParsed || (filters.shopId !== null && filters.shopId !== undefined ? filters.shopId : null)
            if (shopIdToFilter) {
                shops = shops.filter((shop) => shop.id === Number(shopIdToFilter))
                // Falls Shop nicht in der Liste gefunden wird, versuche es in data.shops
                if (shops.length === 0 && data?.shops) {
                    const foundShop = data.shops.find((shop) => shop.id === Number(shopIdToFilter))
                    if (foundShop) {
                        shops = [foundShop]
                    }
                }
            }
            return shops.map((shop) => ({
                name: (
                    <>
                        <span title={shop.name} className="d-inline-block text-truncate">
                            {localStorage.getItem("showLongShopname") === "false"
                                ? shop.shortName
                                    ? shop.shortName
                                    : shop.name
                                : shop.name}
                        </span>
                        <span
                            title={countries.getName(shop.lang, i18n.language)}
                            className={"mx-1 align-top fi fi-" + shop.lang}
                        />
                    </>
                ),
                shopId: shop.id,
                propertyName: shop.name,
                center: "true",
                sortable: true,
                maxWidth: "132px",
                omit: false,
                compact: true,
                cell: (row) => (
                    <PPTableCellPrice
                        foreignShop={row.foreignShopsProductInformations.find(function (item) {
                            return item.shopname === shop.name && item.lang === shop.lang
                        })}
                        shopName={shop.name + " " + shop.lang.toUpperCase()}
                        shopId={shop.id}
                        shopDomain={shop.domain}
                        shopLang={shop.lang.toLowerCase()}
                        row={row}
                        changeSelectedCell={props.changeSelectedCell}
                        changeSelectedRow={props.changeSelectedRow}
                        presetShopIds={presetShopIds}
                        currencyIsoCode={currencyIsoCode}
                        tariffComparisonMode={tariffComparisonMode}
                    />
                )
            }))
        }

        function formatGenericColumns(columnName, value) {
            switch (columnName) {
                case "TopOffer":
                    value = PPUtils.getBooleanValue(value, t)
                    break
            }
            return value
        }

        const createBaseColums = (vColumns) => {
            if (filters.shopId) {
                let shop = data?.shops?.find((vShop) => vShop.id === Number(filters.shopId))
                let alreayContainsPriceColumn = vColumns?.filter(
                    (column) => column.propertyName == "price_" + shop?.lang
                )
                if (
                    shop !== null &&
                    shop !== undefined &&
                    shop.lang !== "de" &&
                    alreayContainsPriceColumn.length == 0
                ) {
                    vColumns?.push({ order: vColumns.length, propertyName: "price_" + shop?.lang })
                }
            }

            return vColumns.map((column) => {
                if (
                    column.propertyName.toLowerCase().includes("price") ||
                    ["formatprice", "formatnormal"].includes(column.frontendv2format?.toLowerCase()) ||
                    ["Versandkosten", "UVP"].includes(column.propertyName) ||
                    PPUtils.isBooleanColumn(column.propertyName)
                ) {
                    return {
                        name: PPUtils.getMappedColumnName(column.propertyName, t, i18n, tariffComparisonMode),
                        propertyName: column.propertyName,
                        center: "true",
                        sortable: true,
                        maxWidth: "132px",
                        fixed: true,
                        cell: (row) => (
                            <PPTableCellPrice
                                row={row}
                                columnName={column.propertyName}
                                columnFormat={column.frontendv2format}
                                changeSelectedCell={props.changeSelectedCell}
                                changeSelectedRow={props.changeSelectedRow}
                                presetShopIds={presetShopIds}
                                currencyIsoCode={currencyIsoCode}
                                tariffComparisonMode={tariffComparisonMode}
                            />
                        )
                    }
                } else if (column.propertyName === "imageUrl") {
                    return {
                        name: PPUtils.getMappedColumnName(column.propertyName, t, i18n, tariffComparisonMode),
                        center: "true",
                        sortable: false,
                        maxWidth: "132px",
                        cell: (row) => <PPPictureBoxLoad image={row?.imageUrl} className={"picturebox shadow"} />
                    }
                } else {
                    return {
                        name: PPUtils.getMappedColumnName(column.propertyName, t, i18n, tariffComparisonMode),
                        propertyName: column.propertyName,
                        center: "true",
                        sortable: true,
                        wrap: true,
                        maxWidth: "132px",
                        cell: (row) => {
                            if (row.genericColumns !== undefined && column.propertyName in row.genericColumns) {
                                return formatGenericColumns(column.propertyName, row.genericColumns[column.propertyName])
                            }
                            const value = row[column.propertyName]
                            if (value?.length > 41) {
                                return value.replace(/^(.{40}[^\s]*).*/, "$1") + " ..."
                            }
                            return value
                        }
                    }
                }
            })
        }

        if (data?.pricetable.preset) {
            presetShopIds = data?.pricetable?.preset?.shops?.map((e) => e.shop.id)
            if (data?.pricetable?.currencyIsoCode !== undefined) {
                currencyIsoCode = data?.pricetable?.currencyIsoCode
            }
            setColumns(
                createBaseColums(data.pricetable.preset.columns).concat(
                    createShopColumns(data.pricetable.preset.shops.map((x) => x.shop))
                )
            )
        } else if (data?.shops) {
            if (data?.pricetable?.currencyIsoCode !== undefined) {
                currencyIsoCode = data?.pricetable?.currencyIsoCode
            }
            setColumns(createShopColumns(data.shops))
        }
    }, [data, props.changeSelectedCell, props.changeSelectedRow, shopIdFromUrlParsed, filters.shopId])

    useEffect(() => {
        props.productCountChange(data?.pricetable?.totalProducts)
        if (
            !window.location.href.includes("pricetable/") &&
            (props.presetId === null || props.presetId === undefined)
        ) {
            props.changePresetId(data?.pricetable?.preset?.id)
        }
    }, [data, props, props.productCountChange])

    const handleSort = (vColumn, vSortDirection) => {
        setSortColumnName(vColumn)
        setSortDirection(vSortDirection)
    }

    useSubscription(INSTANT_CRAWL_SUBSCRIPTION, {
        skip: isStandalone(),
        variables: { channel: "InstantCrawls" + props?.userId },
        onData: ({ data: { vData } }) => {
            if (vData !== undefined && vData.instantCrawlSub.responseCode === 200) {
                refetch()
            }
        }
    })

    if (error) return <PPErrorDisplay error={error} />

    const totalProducts = data?.pricetable?.totalProducts ?? 0
    const pageTotal = Math.max(1, Math.ceil(totalProducts / perPage) || 1)
    const rangeFrom = totalProducts === 0 ? 0 : (page - 1) * perPage + 1
    const rangeTo = Math.min(page * perPage, totalProducts)

    function goToPage(nextPage) {
        const parsed = parseInt(nextPage, 10)
        if (Number.isNaN(parsed)) {
            return
        }
        setPage(Math.min(pageTotal, Math.max(1, parsed)))
    }

    return (
        <div id="pricetable_maindiv" ref={ref}>
            <div className="card shadow">
                <div className="card-body">
                    <PPPriceTableHeader
                        presetId={data?.pricetable?.preset.id}
                        preset={data?.pricetable?.preset}
                        changePresetId={props.changePresetId}
                        presets={data?.settings?.presets}
                        refetchData={refetch}
                        onChangeCatFilter={(cats) => setFilters(cats)}
                        triggerPricetableExport={triggerPricetableExport}
                        countProducts={data?.pricetable.totalProducts}
                        handleSort={handleSort}
                        filters={filters}
                    />
                    <div className={"datatable-wrapper"}>
                        <DataTable
                            noHeader
                            fixedHeader={true}
                            fixedHeaderScrollHeight="100%"
                            columns={columns}
                            data={data?.pricetable?.productPrices}
                            customStyles={customStyles}
                            striped={true}
                            progressPending={loading}
                            progressComponent={<PPLoadingIndicator leftSide={true} />}
                            onSort={handleSort}
                            sortServer
                            persistTableHead
                            expandableRows
                            expandableRowsComponent={PPExpandedRow}
                            noDataComponent={
                                    <div className={"nodata"}>
                                        {t("pricetable.datatable.nodata")}
                                        <br />
                                        <br />
                                        {sortDirection != null && sortColumnName != null ? (
                                                <button
                                                    id="buttonResetSorting"
                                                    className="btn btn-outline-primary mx-1"
                                                    type="button"
                                                    onClick={() => handleSort(null, null)}
                                                >
                                                    <i className="fas fa-sort" />{" "}
                                                    {t("single.reset")}
                                                </button>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                            }
                        />
                    </div>
                    <div className="pricetable-footer">
                        <div className="pricetable-footer-meta">
                            {data?.pricetable?.importFeedDate && (
                                <div className="datatable_importfeeddate">
                                    <div className="text">
                                        {t("single.data_import_feed")}:{" "}
                                        {new Intl.DateTimeFormat(i18n.language, {
                                            year: "numeric",
                                            month: "long",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        }).format(new Date(data?.pricetable?.importFeedDate))}
                                    </div>
                                    <PPUploadImport />
                                </div>
                            )}
                        </div>
                        <div className="pricetable-footer-pager">
                            <label className="pricetable-footer-pagesize">
                                {t("pricetable.datatable.rows_per_page")}
                                <select
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value))
                                        setPage(1)
                                    }}
                                >
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                </select>
                            </label>
                            <span className="pricetable-footer-range">
                                {rangeFrom}-{rangeTo} {t("pricetable.datatable.of")} {totalProducts}
                            </span>
                            {pageTotal > 1 && (
                                <div className="datatableChangePagesDirect">
                                    <input
                                        id="inputDatatableChangePagesDirect"
                                        name="inputDatatableChangePagesDirect"
                                        type="text"
                                        key={page}
                                        defaultValue={page}
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                goToPage(e.target.value)
                                            }
                                        }}
                                    />
                                    /{pageTotal}
                                </div>
                            )}
                            <div className="pricetable-footer-nav">
                                <button
                                    type="button"
                                    disabled={page <= 1}
                                    onClick={() => goToPage(1)}
                                    aria-label={t("pricetable.datatable.first_page")}
                                >
                                    <i className="fas fa-angle-double-left" aria-hidden="true" />
                                </button>
                                <button
                                    type="button"
                                    disabled={page <= 1}
                                    onClick={() => goToPage(page - 1)}
                                    aria-label={t("pricetable.datatable.prev_page")}
                                >
                                    <i className="fas fa-angle-left" aria-hidden="true" />
                                </button>
                                <button
                                    type="button"
                                    disabled={page >= pageTotal}
                                    onClick={() => goToPage(page + 1)}
                                    aria-label={t("pricetable.datatable.next_page")}
                                >
                                    <i className="fas fa-angle-right" aria-hidden="true" />
                                </button>
                                <button
                                    type="button"
                                    disabled={page >= pageTotal}
                                    onClick={() => goToPage(pageTotal)}
                                    aria-label={t("pricetable.datatable.last_page")}
                                >
                                    <i className="fas fa-angle-double-right" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

PPPriceTable.whyDidYouRender = false

export default PPPriceTable
